import React from 'react'
import { SubmitHandler } from 'react-hook-form'
import { BodyParams, FormDataBase, FormWrapper, onSubmit } from '../common/FormBase'
import { idField, machineCategoryField, requiredTextField } from '../common/fields'

// -- Define MachineTypeFormData
export interface MachineTypeFormData extends FormDataBase {
  id?: string
  manufacturer: string
  category: string
  model: string
}

// -- Define props with onSubmit
export interface MachineTypeFormParams extends BodyParams<MachineTypeFormData> {
  onSubmit: onSubmit<MachineTypeFormData>
}

// -- Main form body
export const SuperAdminMachineTypeBody = (params: BodyParams<MachineTypeFormData>) => {
  const fieldProps = { ...params, fieldName: "" }
  return (
    <>
      {id(fieldProps)}
      {manufacturer(fieldProps)}
      {category(fieldProps)}
      {model(fieldProps)}
    </>
  )
}

// -- Edit form
export const SuperAdminEditMachineTypeForm = (params: MachineTypeFormParams) => {
  const formHandler: SubmitHandler<MachineTypeFormData> = (data) => {
    params.onSubmit(data)
  }
  return (
    <FormWrapper<MachineTypeFormData> {...params} formName='machinetype' onSubmit={formHandler}>
      <SuperAdminMachineTypeBody {...params} />
    </FormWrapper>
  )
}

// -- Insert form
export const SuperAdminInsertMachineTypeForm = (params: MachineTypeFormParams) => {
  const formHandler: SubmitHandler<MachineTypeFormData> = (data) => {
    params.onSubmit(data)
  }
  return (
    <FormWrapper<MachineTypeFormData> {...params} formName='machinetype' onSubmit={formHandler}>
      <SuperAdminMachineTypeBody {...params} />
    </FormWrapper>
  )
}

// -- Field wrappers
export const id = (props: any) =>
  idField<MachineTypeFormData>()({
    ...props,
    fieldName: props.fieldName || 'id',
    formName: props.formName || 'machinetype',
  })

export const manufacturer = (props: any) =>
  requiredTextField<MachineTypeFormData>()({
    ...props,
    fieldName: props.fieldName || 'manufacturer',
    formName: props.formName || 'machinetype',
  })

export const category = (props: any) =>
  machineCategoryField<MachineTypeFormData>()({
    ...props,
    fieldName: props.fieldName || 'category',
    formName: props.formName || 'machinetype',
  })

export const model = (props: any) =>
  requiredTextField<MachineTypeFormData>()({
    ...props,
    fieldName: props.fieldName || 'model',
    formName: props.formName || 'machinetype',
  })